<ng-container>

  <div class="flex-container">
    <div class="width100">
      <span class="text-center">Adjuntar documento.</span>
      <app-help key='Inversion6'></app-help>
      <hr>
    </div>

    <div class="width100 text-center">
      <label for="img-input" class="pic-hover me-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          class="icon"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path
            d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54a6 6 0 0 1 -6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1 -6 6zM128 152c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM96 352h320v-80l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0L192 304l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L96 304v48z" />
        </svg>
        <span class="black-text">Imagen</span>
        <app-help key='Gastos6'></app-help>
      </label>
      <input matinput id="img-input" type="file" (change)="uploadImage($event)" placeholder="Upload file"
        accept=".png,.jpg">

      <label for="pdf-input" class="pdf-hover me-4">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"
          class="icon"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path
            d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z" />
        </svg>
        <span class="black-text">PDF</span>
        <app-help key='Gastos7'></app-help>
      </label>
      <input matinput id="pdf-input" type="file" (change)="uploadPDF($event)" placeholder="Upload file" accept=".pdf">

      <label class="pdf-hover me-4" (click)="getFromFiles()" *ngIf="showConvfactFiles === true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          class="icon"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path
            d="M464 128H272l-54.6-54.6c-6-6-14.1-9.4-22.6-9.4H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zm0 272H48V112h140.1l54.6 54.6c6 6 14.1 9.4 22.6 9.4H464v224z" />
        </svg>
        <span class="black-text">Ficheros</span>
        <app-help key='Gastos8'></app-help>
      </label>
    </div>

    <div class="width100 text-center mt-5">
      <ng-container *ngIf="loadingFile">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
      </ng-container>
    </div>
  </div>

</ng-container>
